import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
    { label: "Chalés", href: "#chales" },
    { label: "Decoração Romântica", href: "#decoracao" },
    { label: "Reserva", href: "#reserva" },
    { label: "Dúvidas", href: "#faq" },
    { label: "Contato", href: "#contato" },
];

export default function Navbar({ onNavigate }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (href) => {
        setOpen(false);
        onNavigate(href);
    };

    return (
        <header
            data-testid="main-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
                scrolled || open
                    ? "backdrop-blur-xl bg-stone-50/80 border-b border-stone-200/60"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
                <button
                    data-testid="nav-logo-button"
                    onClick={() => go("#topo")}
                    className="flex items-center gap-3 group"
                >
                    <img
                        src="/images/logo.jpg"
                        alt="Chalés Boutique da Serra"
                        className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover transition-transform duration-500 group-hover:rotate-6"
                    />
                    <span className={`text-xs md:text-sm font-bold uppercase tracking-[0.2em] transition-colors ${scrolled || open ? "text-stone-900" : "text-stone-50"}`}>
                        Chalés Boutique da Serra
                    </span>
                </button>

                <nav className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-link-${l.href.slice(1)}`}
                            onClick={() => go(l.href)}
                            className={`text-xs font-bold uppercase tracking-widest transition-colors hover:opacity-60 ${
                                scrolled ? "text-stone-700" : "text-stone-100"
                            }`}
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-reserve-button"
                        onClick={() => go("#reserva")}
                        className="bg-emerald-900 text-stone-50 text-xs font-bold uppercase tracking-widest px-6 py-3 hover:bg-emerald-950 transition-colors"
                    >
                        Reservar
                    </button>
                </nav>

                <button
                    data-testid="nav-mobile-toggle"
                    className={`lg:hidden ${scrolled || open ? "text-stone-900" : "text-stone-50"}`}
                    onClick={() => setOpen(!open)}
                    aria-label="Menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <nav className="lg:hidden border-t border-stone-200/60 bg-stone-50/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-mobile-link-${l.href.slice(1)}`}
                            onClick={() => go(l.href)}
                            className="text-left text-sm font-bold uppercase tracking-widest text-stone-800"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-mobile-reserve-button"
                        onClick={() => go("#reserva")}
                        className="bg-emerald-900 text-stone-50 text-xs font-bold uppercase tracking-widest px-6 py-4"
                    >
                        Reservar
                    </button>
                </nav>
            )}
        </header>
    );
}
